module.exports = __webpack_public_path__ + "images/wallpaper_iphone_trackpad.jpeg?f875c983243ebab0dd7cd12fa993d847";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wallpaper_iphone_trackpad.jpeg
// module id = 95
// module chunks = 0